module.exports = __webpack_public_path__ + "static/media/2840.510cbe85.jpg";